import React from 'react'
import DealerDegitalRetail from './DealerDegitalRetail'
import DealerHero from './DealerHero'
import DealerPowerMoreLoans from './DealerPowerMoreLoans'
import DealerRequestInfo from './DealerRequestInfo'
import DealerSimplify from './DealerSimplify'
import DealerTabs from './DealerTabs'

const DealerIndex = () => {
  return (
    <React.Fragment>
        <DealerHero />
        <DealerSimplify />
        <DealerTabs />
        <DealerDegitalRetail />
        <DealerPowerMoreLoans />
        <DealerRequestInfo />
    </React.Fragment>
  )
}

export default DealerIndex